import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61667a7f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tag-container" }
const _hoisted_2 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.text, (tag) => {
      return (_openBlock(), _createElementBlock("div", { key: tag }, [
        _createElementVNode("button", {
          class: "tag-chip",
          id: tag
        }, _toDisplayString(tag), 9, _hoisted_2)
      ]))
    }), 128))
  ]))
}